import $ from 'jquery';
import { removeElement } from 'helpers';
/* global google */

function MarkerMapBaloon(objectId, marker, html, map, mapBaloonManager) {
  this.id = objectId;
  this.marker = marker;
  this.html = html;
  this.containerElement = null;
  this.baloonElement = null;
  this.baloonContentElement = null;
  this.mapObject = map;
  this.mapBaloonManager = mapBaloonManager;
  this.closeBaloonButton = null;
  this.closeBaloonHandler = null;
}

MarkerMapBaloon.prototype = new google.maps.OverlayView();

MarkerMapBaloon.prototype.onAdd = function() {
  this.createBaloonElements();
  const panes = this.getPanes();
  panes.floatPane.appendChild(this.containerElement);
};

MarkerMapBaloon.prototype.onRemove = function() {
  removeElement(this.containerElement);
};

MarkerMapBaloon.prototype.draw = function() {
  $(this.baloonContentElement).html(this.html);
  const baloonPosition = this.getBaloonPosition(10);
  $(this.containerElement).css({
    top: baloonPosition.pos.y + 'px',
    left: baloonPosition.pos.x + 'px',
  });
};

MarkerMapBaloon.prototype.getBaloonPosition = function(paddingVertical) {
  const projection = this.getProjection();
  const markerAnchorLocation = projection.fromLatLngToDivPixel(
    this.marker.getPosition(),
  );
  const markerVerticalAnchor = this.marker.getIcon().anchor.y;
  const xPos =
    markerAnchorLocation.x -
    Math.round($(this.containerElement).outerWidth() / 2);
  const yPos =
    markerAnchorLocation.y -
    paddingVertical -
    markerVerticalAnchor -
    $(this.containerElement).outerHeight();
  return {
    pos: {
      x: xPos,
      y: yPos,
    },
  };
};

MarkerMapBaloon.prototype.createBaloonElements = function() {
  this.containerElement = $(
    '<div class="map-bubble" style="position: absolute;"><div class="map-bubble-inner"></div></div>',
  )[0];
  this.baloonContentElement = $('.map-bubble-inner', this.containerElement)[0];
};

export default MarkerMapBaloon;



// WEBPACK FOOTER //
// ./src/js/maps/MapMarkerBaloon.js